import {
  daoRoleListGet,
  daoRolePost,
  daoGetRoleById,
  daoRolePatch,
  daoSocialServiceGet,
  daoRoleApproversGet,
  daoRoleApproversPut,
  daoRoleApproversDelete
} from 'dao/rolemanagement-dao';
import { setHandledErrorCodes} from 'lib/error-message-handling';
const getErrorCodesArray = () => {
  return [
    500
  ];
};

export const ROLEMANAGEMENT_ROLES_REQUEST_GET = 'ROLEMANAGEMENT_ROLES_REQUEST_GET';
export const ROLEMANAGEMENT_ROLES_REQUEST_GET_SUCCESS = 'ROLEMANAGEMENT_ROLES_REQUEST_GET_SUCCESS';
export const ROLEMANAGEMENT_ROLES_REQUEST_GET_FAILURE = 'ROLEMANAGEMENT_ROLES_REQUEST_GET_FAILURE';

export const ROLEMANAGEMENT_ROLE_POST = 'ROLEMANAGEMENT_ROLE_POST';
export const ROLEMANAGEMENT_ROLE_POST_SUCCESS = 'ROLEMANAGEMENT_ROLE_POST_SUCCESS';
export const ROLEMANAGEMENT_ROLE_POST_FAILURE = 'ROLEMANAGEMENT_ROLE_POST_FAILURE';

export const ROLEMANGEMENT_GETBY_ROLE_ID = 'ROLEMANGEMENT_GETBY_ROLE_ID';
export const ROLEMANGEMENT_GETBY_ROLE_ID_SUCCESS = 'ROLEMANGEMENT_GETBY_ROLE_ID_SUCCESS';
export const ROLEMANGEMENT_GETBY_ROLE_ID_FAILURE = 'ROLEMANGEMENT_GETBY_ROLE_ID_FAILURE';

export const ROLEMANAGEMENT_ROLE_PATCH = 'ROLEMANAGEMENT_ROLE_PATCH';
export const ROLEMANAGEMENT_ROLE_PATCH_SUCCESS = 'ROLEMANAGEMENT_ROLE_PATCH_SUCCESS';
export const ROLEMANAGEMENT_ROLE_PATCH_FAILURE = 'ROLEMANAGEMENT_ROLE_PATCH_FAILURE';

export const ROLEMANAGEMENT_ROLE_APPROVERS_GET = 'ROLEMANAGEMENT_ROLE_APPROVERS_GET';
export const ROLEMANAGEMENT_ROLE_APPROVERS_GET_SUCCESS = 'ROLEMANAGEMENT_ROLE_APPROVERS_GET_SUCCESS';
export const ROLEMANAGEMENT_ROLE_APPROVERS_GET_FAILURE = 'ROLEMANAGEMENT_ROLE_APPROVERS_GET_FAILURE';

export const ROLEMANAGEMENT_ROLE_APPROVERS_PUT = 'ROLEMANAGEMENT_ROLE_APPROVERS_PUT';
export const ROLEMANAGEMENT_ROLE_APPROVERS_PUT_SUCCESS = 'ROLEMANAGEMENT_ROLE_APPROVERS_PUT_SUCCESS';
export const ROLEMANAGEMENT_ROLE_APPROVERS_PUT_FAILURE = 'ROLEMANAGEMENT_ROLE_APPROVERS_PUT_FAILURE';

export const ROLEMANAGEMENT_ROLE_APPROVERS_DELETE = 'ROLEMANAGEMENT_ROLE_APPROVERS_DELETE';
export const ROLEMANAGEMENT_ROLE_APPROVERS_DELETE_SUCCESS = 'ROLEMANAGEMENT_ROLE_APPROVERS_DELETE_SUCCESS';
export const ROLEMANAGEMENT_ROLE_APPROVERS_DELETE_FAILURE = 'ROLEMANAGEMENT_ROLE_APPROVERS_DELETE_FAILURE';

export const SOCIALSERVICE_REQUEST_GET = 'SOCIALSERVICE_REQUEST_GET';
export const SOCIALSERVICE_REQUEST_GET_SUCCESS = 'SOCIALSERVICE_REQUEST_GET_SUCCESS';
export const SOCIALSERVICE_REQUEST_GET_FAILURE = 'SOCIALSERVICE_REQUEST_GET_FAILURE';


export const initialState = {
  data:{
    roles: [],
  },
  isLoading: true,
  approversLoading: true,
  socialServiceRequestIsLoading: true
};

export const roleManagementIsLoading = (state) => state.roleManagement.isLoading;
export const roleManagementRoles = (state) => (state.roleManagement && state.roleManagement.data.roles)? state.roleManagement.data.roles : [];
export const getApproversIsLoading = (state) => state.roleManagement.approversLoading;
export const socialServiceRequestIsLoading = (state) => state.roleManagement.socialServiceRequestIsLoading;

// ------------------------------------
// Actions
// ------------------------------------
export const roleManagementRolesRequestGetSuccess = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLES_REQUEST_GET_SUCCESS,
  payload,
});

export const roleManagementRolesRequestGetFailure = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLES_REQUEST_GET_FAILURE,
  payload,
});

export const roleManagementRolesRequestGet = () => dispatch => {
  dispatch({
    type: ROLEMANAGEMENT_ROLES_REQUEST_GET,
  });

  return daoRoleListGet()
    .then(
      response => dispatch(roleManagementRolesRequestGetSuccess(response.data)),
      ex => dispatch(roleManagementRolesRequestGetFailure(ex)),
    );
};

export const roleManagementPostSuccess = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_POST_SUCCESS,
  payload,
});

export const roleManagementPostFailure = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_POST_FAILURE,
  payload,
});

export const roleManagementPost = (payload) => dispatch => {
  dispatch({
    type: ROLEMANAGEMENT_ROLE_POST,
  });

  return daoRolePost(payload)
    .then(
      response => dispatch(roleManagementPostSuccess(response.data)),
      ex => {
        dispatch(roleManagementPostFailure(ex));
        return Promise.reject(ex);
      },
    );
};

export const getRoleByIdSuccess = (payload = {}) => ({
  type: ROLEMANGEMENT_GETBY_ROLE_ID_SUCCESS,
  payload,
});

export const getRoleByIdFailure = (payload = {}) => ({
  type: ROLEMANGEMENT_GETBY_ROLE_ID_FAILURE,
  payload,
});

export const getRoleByIdRequest = (id) => dispatch => {
  dispatch({
    type: ROLEMANGEMENT_GETBY_ROLE_ID,
  });

  return daoGetRoleById(id)
    .then(
      response => dispatch(getRoleByIdSuccess(response.data)),
      ex => dispatch(getRoleByIdFailure(ex)),
    );
};

export const roleManagementRolePatchSuccess = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_PATCH_SUCCESS,
  payload,
});

export const roleManagementRolePatchFailure = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_PATCH_FAILURE,
  payload,
});

export const roleManagementRolePatch = (id,payload) => dispatch => {
  dispatch({
    type: ROLEMANAGEMENT_ROLE_PATCH,
  });

  return daoRolePatch(id,payload)
    .then(
      response => dispatch(roleManagementRolePatchSuccess(response.data)),
      ex => {
        dispatch(roleManagementRolePatchFailure(ex));
        return Promise.reject(ex);
      },
    );
};

export const roleManagementRoleApproversGetSuccess = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_APPROVERS_GET_SUCCESS,
  payload,
});

export const roleManagementRoleApproversGetFailure = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_APPROVERS_GET_FAILURE,
  payload,
});

export const roleManagementRoleApproversGet = (roleid) => dispatch => {
  dispatch({
    type: ROLEMANAGEMENT_ROLE_APPROVERS_GET,
  });
  return daoRoleApproversGet(roleid)
    .then(
      response => dispatch(roleManagementRoleApproversGetSuccess(response.data)),
      ex => dispatch(roleManagementRoleApproversGetFailure(ex)),
    );
};

export const roleManagementRoleApproversPutSuccess = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_APPROVERS_PUT_SUCCESS,
  payload,
});

export const roleManagementRoleApproversPutFailure = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_APPROVERS_PUT_FAILURE,
  payload,
});

export const roleManagementRoleApproversPut = (roleid,approver,payload={}) => dispatch => {
  dispatch({
    type: ROLEMANAGEMENT_ROLE_APPROVERS_PUT,
  });
  return daoRoleApproversPut(roleid,approver,payload)
    .then(
      response => dispatch(roleManagementRoleApproversPutSuccess(response.data)),
      ex => {
        dispatch(roleManagementRoleApproversPutFailure(ex));
        return Promise.reject(ex);
      },
    );
};

export const roleManagementRoleApproversDeleteSuccess = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_APPROVERS_DELETE_SUCCESS,
  payload,
});

export const roleManagementRoleApproversDeleteFailure = (payload = {}) => ({
  type: ROLEMANAGEMENT_ROLE_APPROVERS_DELETE_FAILURE,
  payload,
});

export const roleManagementRoleApproversDelete = (roleid,approver) => dispatch => {
  dispatch({
    type: ROLEMANAGEMENT_ROLE_APPROVERS_DELETE,
  });
  return daoRoleApproversDelete(roleid,approver)
    .then(
      response => dispatch(roleManagementRoleApproversDeleteSuccess(response.data)),
      ex => {
        dispatch(roleManagementRoleApproversDeleteFailure(ex));
        return Promise.reject(ex);
      },
    );
};

export const socialServiceRequestGetSuccess = (payload = {}) => ({
  type: SOCIALSERVICE_REQUEST_GET_SUCCESS,
  payload,
});

export const socialServiceRequestGetFailure = (payload = {}) => ({
  type: SOCIALSERVICE_REQUEST_GET_FAILURE,
  payload,
});

export const socialServiceRequestGet = (text) => dispatch => {
  dispatch({
    type: SOCIALSERVICE_REQUEST_GET,
  });
  setHandledErrorCodes(getErrorCodesArray());
  return daoSocialServiceGet(text)
    .then(
      response => dispatch(socialServiceRequestGetSuccess(response.data)),
      ex => dispatch(socialServiceRequestGetFailure(ex)),
    );
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [ROLEMANAGEMENT_ROLES_REQUEST_GET]: (state) => ({...state, isLoading: true}),
  [ROLEMANAGEMENT_ROLES_REQUEST_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          roles:action.payload,
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [ROLEMANAGEMENT_ROLES_REQUEST_GET_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [ROLEMANAGEMENT_ROLE_POST]: (state) => ({...state, isLoading: true}),
  [ROLEMANAGEMENT_ROLE_POST_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          newRole: {
            ...action.payload
          },
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [ROLEMANAGEMENT_ROLE_POST_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [ROLEMANGEMENT_GETBY_ROLE_ID]: (state) => ({...state, isLoading: true}),
  [ROLEMANGEMENT_GETBY_ROLE_ID_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        role: action.payload,
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [ROLEMANGEMENT_GETBY_ROLE_ID_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [ROLEMANAGEMENT_ROLE_PATCH]: (state) => ({...state, isLoading: true}),
  [ROLEMANAGEMENT_ROLE_PATCH_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [ROLEMANAGEMENT_ROLE_PATCH_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [ROLEMANAGEMENT_ROLE_APPROVERS_GET]: (state) => ({...state, approversLoading: true}),
  [ROLEMANAGEMENT_ROLE_APPROVERS_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          approvers: action.payload,
        },
        approversLoading: false,
      };
    }
    return {...state, approversLoading: false};
  },
  [ROLEMANAGEMENT_ROLE_APPROVERS_GET_FAILURE]: (state) => ({
    ...state,
    approversLoading: false,
  }),

  [ROLEMANAGEMENT_ROLE_APPROVERS_PUT]: (state) => ({...state, isLoading: true}),
  [ROLEMANAGEMENT_ROLE_APPROVERS_PUT_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          approvers: action.payload,
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [ROLEMANAGEMENT_ROLE_APPROVERS_PUT_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [ROLEMANAGEMENT_ROLE_APPROVERS_DELETE]: (state) => ({...state, isLoading: true}),
  [ROLEMANAGEMENT_ROLE_APPROVERS_DELETE_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        data: {
          ...state.data,
          approvers: action.payload,
        },
        isLoading: false,
      };
    }
    return {...state, isLoading: false};
  },
  [ROLEMANAGEMENT_ROLE_APPROVERS_DELETE_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

  [SOCIALSERVICE_REQUEST_GET]: (state) => ({...state, socialServiceRequestIsLoading: true}),
  [SOCIALSERVICE_REQUEST_GET_SUCCESS]: (state, action) => {
    if (typeof action.payload === 'object') {
      return {
        ...state,
        socialServiceData: action.payload,
        socialServiceRequestIsLoading: false,
      };
    }
    return {...state,socialServiceRequestIsLoading: false};
  },
  [SOCIALSERVICE_REQUEST_GET_FAILURE]: (state) => ({
    ...state,
    isLoading: false,
  }),

};

const rolesReducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
};
export default rolesReducer;
